"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PINTabs = void 0;
var React = __importStar(require("react"));
var PropTypes = __importStar(require("prop-types"));
var PINTabs = /** @class */ (function (_super) {
    __extends(PINTabs, _super);
    function PINTabs() {
        // PropTypes
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // State
        _this.state = {
            tabs: [],
            selectedTab: _this.props.selectedTab || 0
        };
        // Private methods
        _this.getTabsFromChildren = function () { return (React.Children.map(_this.props.children, function (child) {
            if (!child || !child.props || !child.props.tabTitle) {
                return null;
            }
            var _a = child.props, id = _a.id, tabTitle = _a.tabTitle, props = __rest(_a, ["id", "tabTitle"]);
            return {
                title: tabTitle,
                id: id,
                component: child.type,
                componentProps: props
            };
        }) || []).filter(function (child) { return (child !== null); }); };
        // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'index' implicitly has an 'any' type.
        _this.onTabClick = function (index) {
            if (_this.props.static) {
                return;
            }
            if (index >= 0 && index < _this.state.tabs.length) {
                _this.setState(function () { return ({ selectedTab: index }); });
            }
            if (!_this.props.onChange) {
                return;
            }
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'component' does not exist on type 'never... Remove this comment to see the full error message
            _this.props.onChange(_this.state.tabs[index].component, index);
        };
        // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'id' implicitly has an 'any' type.
        _this.isSelectedTab = function (id, index) {
            if (typeof _this.state.selectedTab === "number") {
                return index === _this.state.selectedTab;
            }
            else if (typeof _this.state.selectedTab === "string") {
                return id === _this.state.selectedTab;
            }
            return false;
        };
        return _this;
    }
    // Lifecycle
    PINTabs.prototype.componentDidMount = function () {
        this.UNSAFE_componentWillReceiveProps(this.props);
    };
    // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'nextProps' implicitly has an 'any' type... Remove this comment to see the full error message
    PINTabs.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        var _this = this;
        this.setState(function () { return ({ tabs: nextProps.tabs || _this.getTabsFromChildren() }); }, function () {
            var index = 0;
            if (!nextProps.selectedTab) {
                // @ts-expect-error ts-migrate(2339) FIXME: Property 'isHeaderOnly' does not exist on type 'ne... Remove this comment to see the full error message
                index = _this.state.tabs.findIndex(function (tab) { return (!tab.isHeaderOnly); });
            }
            else if (typeof nextProps.selectedTab !== "string") {
                return;
            }
            _this.state.tabs.forEach(function (tab, i) {
                // @ts-expect-error ts-migrate(2339) FIXME: Property 'id' does not exist on type 'never'.
                if (tab.id === nextProps.selectedTab) {
                    index = i;
                }
            });
            _this.setState(function () { return ({ selectedTab: index }); });
        });
    };
    PINTabs.prototype.render = function () {
        var _this = this;
        if (!this.state.tabs.length) {
            return null;
        }
        return (React.createElement("div", { className: (this.props.className || "") + " pintabs" },
            React.createElement("ul", { className: "pintabs-header" }, this.state.tabs.map(function (tab, index) { return (
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'isHeaderOnly' does not exist on type 'ne... Remove this comment to see the full error message
            tab.isHeaderOnly ? (
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'component' does not exist on type 'never... Remove this comment to see the full error message
            React.createElement(tab.component, __assign({ key: index }, tab.componentProps))) : (React.createElement(PINTab
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'title' does not exist on type 'never'.
            , { 
                // @ts-expect-error ts-migrate(2339) FIXME: Property 'title' does not exist on type 'never'.
                key: "pintabs" + tab.title + index, 
                // @ts-expect-error ts-migrate(2339) FIXME: Property 'title' does not exist on type 'never'.
                title: tab.title, 
                // @ts-expect-error ts-migrate(2339) FIXME: Property 'id' does not exist on type 'never'.
                active: _this.isSelectedTab(tab.id, index), onClick: function () { _this.onTabClick(index); }, 
                // @ts-expect-error ts-migrate(2339) FIXME: Property 'headerClassName' does not exist on type ... Remove this comment to see the full error message
                headerClassName: tab.headerClassName || "" }))); })),
            React.createElement("div", { className: (this.props.contentClassName || "") + " pintabs-content" }, this.state.tabs.map(function (tab, index) {
                // @ts-expect-error ts-migrate(2339) FIXME: Property 'isHeaderOnly' does not exist on type 'ne... Remove this comment to see the full error message
                if (tab.isHeaderOnly) {
                    return null;
                }
                // @ts-expect-error ts-migrate(2339) FIXME: Property 'props' does not exist on type 'never'.
                var className = (tab.props && tab.props.className) || "";
                // @ts-expect-error ts-migrate(2339) FIXME: Property 'id' does not exist on type 'never'.
                className = className + (_this.isSelectedTab(tab.id, index) ? "" : " d-none");
                // @ts-expect-error ts-migrate(2339) FIXME: Property 'componentProps' does not exist on type '... Remove this comment to see the full error message
                var props = __assign(__assign({}, tab.componentProps), { className: className });
                return (
                // @ts-expect-error ts-migrate(2339) FIXME: Property 'component' does not exist on type 'never... Remove this comment to see the full error message
                React.createElement(tab.component, __assign({ key: index }, props)));
            }))));
    };
    PINTabs.propTypes = {
        tabs: PropTypes.arrayOf(PropTypes.shape({
            title: PropTypes.string.isRequired,
            id: PropTypes.string,
            component: PropTypes.func,
            componentProps: PropTypes.any,
            headerClassName: PropTypes.string,
            isHeaderOnly: PropTypes.bool
        })),
        selectedTab: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        contentClassName: PropTypes.string
    };
    return PINTabs;
}(React.Component));
exports.PINTabs = PINTabs;
var PINTab = function (props) { return (React.createElement("li", { className: "pintab" + (props.active ? " active" : "") + " " + props.headerClassName, onClick: props.onClick }, props.title)); };
//# sourceMappingURL=PINTabs.js.map